import { render, staticRenderFns } from "./LeadDashboard.vue?vue&type=template&id=456399ff&scoped=true&"
import script from "./LeadDashboard.vue?vue&type=script&lang=js&"
export * from "./LeadDashboard.vue?vue&type=script&lang=js&"
import style0 from "./LeadDashboard.vue?vue&type=style&index=0&id=456399ff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456399ff",
  null
  
)

export default component.exports